export default "__VITE_ASSET__CwDAyzKL__"